export default __webpack_public_path__ + "static/media/Ficha_PESTNU-2.a2e33691.png";